import React from "react";
import { SvgIcon } from "@mui/material";

export const CustomCheckboxIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20" fontSize="inherit">
    <rect
      x="0.5"
      y="0.5"
      width="19"
      height="19"
      rx="4.5"
      stroke="#CACACA"
      fill="none"
    />
  </SvgIcon>
);

export const CustomCheckboxCheckedIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20" fontSize="inherit">
    <rect
      x="0.5"
      y="0.5"
      width="19"
      height="19"
      rx="4.5"
      fill="#185CB7"
      stroke="#185CB7"
    />
    <path
      d="M5.5 10.5L8.5 13.5L14.5 7.5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
